import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "info-panel-wrapper" }
const _hoisted_2 = { class: "shift-hint" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CommunityLinks = _resolveComponent("CommunityLinks")!
  const _component_GenericButton = _resolveComponent("GenericButton")!
  const _component_UpdateExists = _resolveComponent("UpdateExists")!
  const _component_VersionInfo = _resolveComponent("VersionInfo")!
  const _component_DefaultContent = _resolveComponent("DefaultContent")!
  const _component_GenericPanel = _resolveComponent("GenericPanel")!

  return (_openBlock(), _createBlock(_component_GenericPanel, {
    "class-name": "info-panel-container",
    title: "INFO PANEL",
    "show-info": ['Default', 'InfoPanel']
  }, {
    "icons-left": _withCtx(() => [
      _createVNode(_component_CommunityLinks)
    ]),
    "icons-right": _withCtx(() => [
      (!_ctx.updateExists)
        ? (_openBlock(), _createBlock(_component_GenericButton, {
            key: 0,
            svg: "version",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showVersionInfo = !_ctx.showVersionInfo)),
            title: 
          _ctx.showVersionInfo ? 'Hide the latest update' : 'Show the latest update'
        
          }, null, 8, ["title"]))
        : _createCommentVNode("", true),
      _createVNode(_component_GenericButton, {
        svg: "refresh",
        onClick: _ctx.reload,
        title: "Reload the app to refresh the content"
      }, null, 8, ["onClick"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.updateExists)
          ? (_openBlock(), _createBlock(_component_UpdateExists, {
              key: 0,
              onUpdateApp: _ctx.refreshApp
            }, null, 8, ["onUpdateApp"]))
          : (_ctx.showVersionInfo)
            ? (_openBlock(), _createBlock(_component_VersionInfo, { key: 1 }))
            : (_openBlock(), _createBlock(_component_DefaultContent, { key: 2 }))
      ]),
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.state.ui.lockInfoPanel
          ? "Info Panel LOCKED!"
          : "Press and hold Shift key to lock the Info Panel"), 1)
    ]),
    _: 1
  }))
}